/* ProudGifts motion layer — vanilla ports of SplitText / SpotlightCard / TiltedCard */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- SplitText: word-by-word reveal for hero + section headings ---------- */
  function split(el) {
    if (!el || el.dataset.pgSplit) return;
    el.dataset.pgSplit = '1';
    var text = el.textContent.trim();
    if (!text) return;
    var words = text.split(/\s+/);
    el.textContent = '';
    words.forEach(function (w, i) {
      var outer = document.createElement('span');
      outer.className = 'pg-word';
      outer.style.setProperty('--i', i);
      var inner = document.createElement('span');
      inner.className = 'pg-word__in';
      inner.textContent = w;
      outer.appendChild(inner);
      el.appendChild(outer);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    el.classList.add('pg-split');
  }

  function initSplit() {
    if (reduce) return;
    document.querySelectorAll('.pg-hero__heading, .pg-desc__title').forEach(function (el) {
      split(el);
    });
    var els = document.querySelectorAll('.pg-split');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pg-split--in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('pg-split--in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('pg-split--in');
      } else {
        io.observe(el);
      }
      setTimeout(function () { el.classList.add('pg-split--in'); }, 1500);
    });
  }

  /* ---------- SpotlightCard: cursor-follow highlight on product cards ---------- */
  function initSpotlight() {
    if (reduce) return;
    document.querySelectorAll('.card-product').forEach(function (card) {
      card.classList.add('pg-spot');
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', ((e.clientX - r.left) / r.width) * 100 + '%');
        card.style.setProperty('--my', ((e.clientY - r.top) / r.height) * 100 + '%');
      });
    });
  }

  /* ---------- TiltedCard: subtle 3D tilt on collection tiles ---------- */
  function initTilt() {
    if (reduce) return;
    var max = 4;
    document.querySelectorAll('.collection-card').forEach(function (card) {
      card.classList.add('pg-tilt');
      var raf = null;
      card.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          var r = card.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          card.style.transform =
            'perspective(900px) rotateX(' + (-py * max).toFixed(2) + 'deg) rotateY(' +
            (px * max).toFixed(2) + 'deg) translateZ(0)';
          raf = null;
        });
      });
      card.addEventListener('pointerleave', function () {
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        card.style.transform = '';
      });
    });
  }


  /* ---------- PDP: cursor-follow zoom on the main product image ---------- */
  function initZoom() {
    if (reduce) return;
    document.querySelectorAll('.product__media').forEach(function (media) {
      var img = media.querySelector('img');
      if (!img || img.dataset.pgZoom) return;
      img.dataset.pgZoom = '1';
      media.classList.add('pg-zoom');
      media.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        var r = media.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(1.55)';
      });
      media.addEventListener('pointerleave', function () {
        img.style.transform = '';
      });
    });
  }

  /* ---------- PDP: stagger reveal for reviews, accordions, delivery steps ---------- */
  function initStagger() {
    if (reduce) return;
    var groups = [
      ['.pg-reviews__grid', '.pg-review'],
      ['.pg-pinfo__in', '.pg-pinfo__item'],
      ['.pg-delivery__steps', 'li'],
      ['.pg-sizes__table tbody', 'tr']
    ];
    groups.forEach(function (g) {
      var host = document.querySelector(g[0]);
      if (!host) return;
      var items = host.querySelectorAll(g[1]);
      if (!items.length) return;
      items.forEach(function (el, i) {
        el.classList.add('pg-stagger');
        el.style.setProperty('--d', i * 45 + 'ms');
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            host.classList.add('pg-stagger--in');
            io.disconnect();
          }
        });
      }, { threshold: 0.15 });
      io.observe(host);
    });
  }

  /* ---------- PDP: click spark on the add-to-cart button ---------- */
  function initSpark() {
    if (reduce) return;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-form__submit, .pg-buynow');
      if (!btn) return;
      var r = btn.getBoundingClientRect();
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;
      for (var i = 0; i < 7; i++) {
        var s = document.createElement('span');
        s.className = 'pg-spark';
        s.style.left = x + 'px';
        s.style.top = y + 'px';
        var a = (Math.PI * 2 * i) / 7;
        s.style.setProperty('--sx', Math.cos(a) * 26 + 'px');
        s.style.setProperty('--sy', Math.sin(a) * 26 + 'px');
        btn.appendChild(s);
        (function (node) { setTimeout(function () { node.remove(); }, 620); })(s);
      }
    });
  }


  /* ---------- CountUp: numbers animate when they enter view ---------- */
  function countUp(el, to, decimals, prefix, suffix) {
    var start = null, dur = 1200;
    function tick(t) {
      if (!start) start = t;
      var p = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      var v = to * eased;
      var num = decimals ? v.toFixed(decimals) : Math.round(v).toLocaleString('en-US');
      el.textContent = (prefix || '') + num + (suffix || '');
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initCountUp() {
    if (reduce) return;
    var jobs = [];
    function add(el, to, decimals, prefix, suffix) { jobs.push([el, to, decimals, prefix || '', suffix || '']); }

    var avg = document.querySelector('.pg-reviews__average');
    if (avg) add(avg, 4.7, 1, '', '');
    var cnt = document.querySelector('.pg-reviews__count');
    if (cnt) add(cnt, 471, 0, '', ' reviews');

    var titles = document.querySelectorAll(
      '.text-with-icons-card__info .h5, .text-with-icons-card__info .h4, .text-with-icons-card__info h3, .text-with-icons__item .h5, .text-with-icons__item h3'
    );
    titles.forEach(function (h) {
      var text = h.textContent;
      var m = text.match(/([\d][\d.,]*)\s*(\+)?/);
      if (!m) return;
      var n = parseFloat(m[1].replace(/,/g, ''));
      if (!(n >= 1000)) return;
      var prefix = text.slice(0, m.index);
      var suffix = text.slice(m.index + m[0].length);
      if (suffix && !/^\s/.test(suffix)) suffix = ' ' + suffix;
      add(h, n, 0, prefix, (m[2] || '') + suffix);
    });

    if (!jobs.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        jobs.forEach(function (j) { if (j[0] === e.target) countUp(j[0], j[1], j[2], j[3], j[4]); });
        io.unobserve(e.target);
      });
    }, { threshold: 0.6 });
    jobs.forEach(function (j) { io.observe(j[0]); });
  }

  function initBlurText() {
    if (reduce) return;
    document.querySelectorAll('.section__heading').forEach(function (h) {
      if (h.dataset.pgBlur) return;
      h.dataset.pgBlur = '1';
      h.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
      h.style.removeProperty('--animation-order');
      var words = h.textContent.trim().split(/\s+/);
      h.textContent = '';
      words.forEach(function (w, i) {
        var sp = document.createElement('span');
        sp.className = 'pg-blur-word';
        sp.style.setProperty('--i', i);
        sp.textContent = w;
        h.appendChild(sp);
        if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
      });
      h.classList.add('pg-blur');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pg-blur--in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.pg-blur').forEach(function (h) { io.observe(h); });
  }

  /* ---------- SpecularButton: highlight follows the cursor on CTAs ---------- */
  function initSpecular() {
    if (reduce) return;
    document.querySelectorAll('.btn-primary, .pg-buynow, .product-form__submit').forEach(function (b) {
      if (b.dataset.pgSpec) return;
      b.dataset.pgSpec = '1';
      b.classList.add('pg-specular');
      b.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        var r = b.getBoundingClientRect();
        b.style.setProperty('--sx', ((e.clientX - r.left) / r.width) * 100 + '%');
        b.style.setProperty('--sy', ((e.clientY - r.top) / r.height) * 100 + '%');
      });
    });
  }

  /* ---------- LogoLoop: payment marks scroll as a slow loop ---------- */
  function initLogoLoop() {
    var host = document.querySelector('.pg-pinfo__pay');
    if (!host || host.dataset.pgLoop) return;
    host.dataset.pgLoop = '1';
    var items = Array.prototype.slice.call(host.children);
    if (!items.length) return;
    host.classList.add('pg-loop');
    var track = document.createElement('div');
    track.className = 'pg-loop__track';
    items.forEach(function (n) { track.appendChild(n.cloneNode(true)); });
    items.forEach(function (n) { track.appendChild(n); });
    host.innerHTML = '';
    host.appendChild(track);
  }

  /* ---------- PDP: fit line under the size picker ---------- */
  function initFitLine() {
    var picker = document.querySelector('.variant-picker');
    if (!picker || picker.dataset.pgFit) return;
    var label = picker.closest('.product-form__input');
    if (!label) return;
    var legend = label.querySelector('legend, .form__label');
    if (!legend || !/size/i.test(legend.textContent)) return;
    picker.dataset.pgFit = '1';
    var p = document.createElement('p');
    p.className = 'pg-fitline';
    p.textContent = 'True to US sizing. Between sizes, go up.';
    label.appendChild(p);
  }


  /* ---------- GlareHover: light streak sweeps across collection tiles ---------- */
  function initGlare() {
    if (reduce) return;
    document.querySelectorAll('.collection-card').forEach(function (card) {
      if (card.dataset.pgGlare) return;
      card.dataset.pgGlare = '1';
      card.classList.add('pg-glare');
      card.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        var r = card.getBoundingClientRect();
        card.style.setProperty('--gx', ((e.clientX - r.left) / r.width) * 100 + '%');
        card.style.setProperty('--gy', ((e.clientY - r.top) / r.height) * 100 + '%');
      });
    });
  }

  /* ---------- ScrollExpand: media frame grows to full width as it enters ---------- */
  function initScrollExpand() {
    if (reduce) return;
    var media = document.querySelector('[id*="custom_content_story"] img');
    if (!media) return;
    var frame = media.closest('div');
    if (!frame || frame.dataset.pgExpand) return;
    frame.dataset.pgExpand = '1';
    frame.classList.add('pg-expand');
    var ticking = false;
    function update() {
      ticking = false;
      var r = frame.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var start = vh;
      var end = vh * 0.35;
      var p = (start - r.top) / (start - end);
      p = Math.max(0, Math.min(1, p));
      frame.style.setProperty('--p', p.toFixed(3));
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }


  /* ---------- PDP: production note under the buy buttons ---------- */
  function initProdNote() {
    var btns = document.querySelector('.product-form__buttons');
    if (!btns || document.querySelector('.pg-prodnote')) return;
    var p = document.createElement('p');
    p.className = 'pg-prodnote';
    p.textContent = 'Printed to order in the US — ships in 2–3 business days. Free shipping over $49.';
    btns.parentNode.insertBefore(p, btns.nextSibling);
  }

  function boot() {
    initSplit();
    initSpotlight();
    initTilt();
    initZoom();
    initStagger();
    initSpark();
    initCountUp();
    initBlurText();
    initSpecular();
    initLogoLoop();
    initFitLine();
    initGlare();
    initScrollExpand();
    initProdNote();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
